<template>
	<div>
		<v-layout 
			row wrap 
			secondary 
			white--text 
			class="app-footer">
			<v-flex xs12>
				<v-layout class="container">
					<v-flex xs12 md5>
						<v-layout row wrap align-center>
							<v-flex xs12>
								<h4 class="app-footer-subtitle">Nuestros productos y principales clientes/partnes:</h4>
							</v-flex>
							<v-flex xs12>
								<v-layout row wrap class="app-footer-logos">
									<v-flex xs6>
										<a
											href="https://feedbackinn.com/"
											target="_blank"
											class="text-decoration-none logo-feedbackinn"
										>
											<img src="/static/images/logos/logo-feedbackinn.png" alt="feedbackinn" height="32">
										</a>
									</v-flex>
									<v-flex xs6>
										<a
											href="https://japisale.com/"
											target="_blank"
											class="text-decoration-none logo-japisale"
										>
											<img src="/static/images/logos/logo-japisale.png" alt="feedbackinn" height="31">
										</a>
									</v-flex>
									<v-flex xs6 class="logo-maki">
										<a
											href="https://makipos.la/"
											target="_blank"
											class="text-decoration-none"
										>
											<img src="/static/images/logos/logo-maki.png" alt="feedbackinn" height="36">
										</a>
									</v-flex>
									<v-flex xs6 class="logo-fenix">
										<a
											href="https://fenixcorp.net/"
											target="_blank"
											class="text-decoration-none"
										>
											<img src="/static/images/logos/logo-fenix.png" alt="feedbackinn" height="43">
										</a>
									</v-flex>
								</v-layout>
							</v-flex>
							<v-flex xs12 class="app-footer-btn-container">
								<a href="https://apprunn.netlify.app/" target="_blank" class="text-decoration-none">
									<v-btn
										class="btn-action btn-auto app-footer-btn white--text"
										color="success"
										depressed
									>
										VISITA APPRUNN.COM
									</v-btn>
								</a>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs12 md7>
						<p class="app-footer-text margin">
							Apprun es un Product Studio que tiene como misión crear productos que solucionen
							la vida de la gente sin importar dónde estén, asegurando su crecimiento constante.
						</p>
						<p class="app-footer-text">
							Desarrollamos plataformas tecnológicas que solucionen problemas a diferentes sectores
							del mercado, luego convertimos estas soluciones en productos que son comercializados por nuestros partners.
						</p>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<div class="wrapper-end bold">
			<p class="mb-0">Derechos reservados <a href="https://www.makipos.la" target="_blank" class="link">makipos.la</a> | Desarrollado por apprunn</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'app-footer',
	};
</script>

<style lang="scss" scoped>
	.text-decoration-none {
		text-decoration: none;
	}

	.app-footer {
		padding: 71px 5% 91px;
		text-align: center;

		@media (min-width: 360px) {
			padding: 71px 7% 91px;
		}

		@media (min-width: 1024px) {
			padding: 70px 7%;
			text-align: left;
		}

		@media (min-width: 1400px) {
			padding: 70px 7%;
		}

		&-btn {
			background: color(white) !important;
			border-radius: 23px !important;
			color: color(green-dark) !important;
			font-size: size(medium);
			font-weight: weight(w900);
			height: 47px !important;
			width: 279px !important;
		}

		&-btn-container {
			display: none;

			@media (min-width: 1024px) {
				display: initial;
			}
		}

		&-title {
			font-size: size(large);
			font-weight: weight(w900);
			margin-bottom: 44px;
			text-transform: uppercase;

			@media (min-width: 1024px) {
				margin-bottom: 48px;
			}
		}

		&-subtitle {
			font-size: size(medium);
			font-weight: weight(w800);
			margin: 0 auto 37px;
			max-width: 60%;

			@media (min-width: 1024px) {
				margin: 0 0 22px;
				max-width: 100%;
			}
		}

		&-text {
			font-size: size(medium16);

			&.margin {
				margin-bottom: 30px;
			}

			@media (min-width: 1024px) {
				padding-left: 8%;
			}
		}

		&-logos {
			margin-bottom: 62px;

			@media (min-width: 1024px) {
				margin-bottom: 21px;
			}
		}

		.logo-feedbackinn, .logo-japisale {
			img {
				margin-bottom: 28px;
			}
		}

		.logo-maki, .logo-fenix {
			@media (min-width: 1024px) {
				padding-left: 20%;
				text-align: center;
			}
		}
	}

	.wrapper-end {
		background: map-get($colors, title-green);
		color: map-get($colors, white);
		padding: 14px;
		text-align: center;
	}

	.link {
		color: map-get($colors, white);
		text-decoration: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/home/second-footer.vue